module.exports = __webpack_public_path__ + "static/media/CAISSpacesBanner_TimeDate.77ffb82d.jpg";